import { Box, HStack } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const PaymentMethodsContainer = Box.withConfig({
  minHeight: 120,
  width: 'full',
  background: primitive.$white,
  borderRadius: 10,
  justifyContent: 'space-between',
});

export const AvailablePayments = Box.withConfig({
  flexDirection: 'row-reverse',
  height: 30,
  backgroundColor: primitive.bk.$lightBrown,
  borderBottomLeftRadius: 10,
  borderBottomRightRadius: 10,
  paddingRight: '$3',
});

export const HorizontalContainer = HStack.withConfig({
  alignItems: 'center',
  marginLeft: '$6',
  space: 4,
});

export const TopContainer = Box.withConfig({
  flex: 1,
  flexDirection: 'row',
  width: 'full',
  justifyContent: 'space-between',
  alignItems: 'center',
});
